<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">settings</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="extraOptions.parent.openReferentiel(data)">{{ data.libelle || ('admin.voyages.travelhub.sbtConfig.referentiel.categorieVoyageur.libelleNonDefini' | translate) }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.code"><strong translate>admin.voyages.travelhub.sbtConfig.referentiel.valeur</strong>{{ data.code }}</li>
            <li><strong translate>admin.voyages.travelhub.sbtConfig.referentiel.defaut</strong>{{ (data.defaut ? 'global.oui' : 'global.non') | translate }}</li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button [matMenuTriggerFor]="listeActions">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #listeActions="matMenu">
            <button mat-menu-item (click)="deleteCategorieVoyageur()" translate="global.actions.supprimer"></button>
        </mat-menu>
    </div>
</div>
